import React, { useState } from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { patchCryptoLink } from 'redux/crypto-links/actions';

import { Dropdown } from 'semantic-ui-react';

import ProLabel from 'components/common/ProLabel';

import './CryptoShowAsDropdown.css';

function CryptoShowAsDropdown(props) {
  const { me, linkItem, patchCryptoLink, parameter } = props;
  const { t } = useTranslation();
  const [currentDisplayMode, setCurrentDisplayMode] = useState(linkItem[parameter]);

  const modeOptions = [
    {
      key: 'copy',
      text: t("Address"),
      value: 'copy',
      isPro: false,
    },
    {
      key: 'qr',
      text: t("QR Code"),
      value: 'qr',
      isPro: true,
    },
    {
      key: 'copy_qr',
      text: t("Address + QR Code"),
      value: 'copy_qr',
      isPro: true,
    },
  ];

  return (
    <div className="crypto-show-as-dropdown__component">
      <div className="label">{t("Show as")}</div>
      <Dropdown
        fluid
        selection
        value={currentDisplayMode}
        options={modeOptions}
      >
        <Dropdown.Menu>
          {modeOptions.map(option => (
            <Dropdown.Item
              key={`dropdown-item-${option.value}-${linkItem.id}`}
              onClick={() => {
                setCurrentDisplayMode(option.value);
                const form = new FormData();
                form.append(parameter, option.value);
                patchCryptoLink(linkItem.id, form);
              }}
              disabled={
                option.isPro &&
                me &&
                me.subscription &&
                !me.subscription.ff_crypto_links
              }
            >
              <div className="dropdown-item-wrapper">
                {option.isPro && <ProLabel />}
                <div className="text">{option.text}</div>
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

CryptoShowAsDropdown.propTypes = {
  patchCryptoLink: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  me: PropTypes.object,
  parameter: PropTypes.string.isRequired,
};

CryptoShowAsDropdown.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);


export default connect(
  mapStateToProps,
  {
    patchCryptoLink,
  },
)(CryptoShowAsDropdown);
